export const getNodeSelectionOpacity = (
  nodeId: string,
  selectedNodeId?: string,
  dimOpacity = 0.15,
): number => {
  if (!selectedNodeId) return 1;
  return nodeId === selectedNodeId ? 1 : dimOpacity;
};

export const getEdgeSelectionOpacity = (
  source: string,
  target: string,
  selectedNodeId?: string,
  dimOpacity = 0.15,
): number => {
  if (!selectedNodeId) return 1;
  return source === selectedNodeId || target === selectedNodeId
    ? 1
    : dimOpacity;
};
